<template>
  <div id="app">
    <header :class="{ loginRegister: isLoginPage }">
      <nav v-if="showHomeButton" tag="ul" id="navbar" class="navbar">
        <section class="secNavTexts">
          <router-link tag="li" to="/home" id="navHome" exact>
            <img src="../public/eSano_white.png" class="navbarIcon">
          </router-link>
          <section v-if="isEditor">
            <router-link tag="li" :to="{ name: 'myStudies' }" id="navStudies" exact>
              {{ 'myStudiesTranslation.myStudies' | translate }}
            </router-link>

            <router-link tag="li" :to="{ name: 'myInterventions' }" id="navInterventions" exact>
              {{ 'myStudiesTranslation.myInterventions' | translate }}
            </router-link>
            <section>
              <button class="dropbtn" id="navMore" @click="showDropdownContent">
                {{ 'myStudiesTranslation.more' | translate }}
                <i class="fa fa-caret-down"></i>
              </button>
              <div class="dropdown-content" :id="dropdownId">
                <router-link tag="li" :to="{ name: 'moreStudies'}" id="navMoreStudies" exact>
                  {{ 'myStudiesTranslation.moreStudies' | translate }}
                </router-link>
                <router-link tag="li" :to="{ name: 'moreInterventions' }" id="navMoreInterventions" exact>
                  {{ 'myStudiesTranslation.moreInterventions' | translate }}
                </router-link>
              </div>
            </section>
          </section>
        </section>

        <div class="secNavButtons">
          <section
            v-if="isDevelopVersion"
            class="devMarker"
            :class="{ devMarkerPadding: routeNeedsDevPadding }"
          >
            Develop
          </section>

          <div class="languageSelection" style="display: inline-block; margin-right: 20px;">
            <div style="position: relative;">
              <i class="fas fa-globe globeIcon"></i>
              <select
                id="inputLanguage"
                class="languageSelectStyling"
                v-model="selectedAppLanguage"
                @change="changeAppLanguage()"
              >
                <option id="inputLanguagede" value="de">
                  Deutsch
                </option>
                <option id="inputLanguageen" value="en">
                  English
                </option>
              </select>
            </div>
          </div>

          <i
            v-if="announcementsAvailable"
            id="navShowHideAnnouncements"
            class="fas fa-bell fa-lg annButton"
            :class="{ annActive: showAnnouncements }"
            v-tooltip="$t('generalTranslation.showHideAnnouncements')"
            @click="showHideAnnouncements"
          ></i>
          <div v-else style="display: inline-block; width: 30px;"></div>
          <router-link
            v-if="isAdmin"
            tag="li"
            :to="{ name: 'adminUsers' }"
            id="navUsers"
            exact
            v-tooltip="$t('adminUsersTranslation.adminFunctions')"
          >
            <i class="fas fa-user-cog fa-lg"></i>
          </router-link>
          <router-link
            v-if="isAdmin"
            tag="li"
            :to="{ name: 'adminAnnouncements' }"
            id="navAnnouncements"
            exact
            v-tooltip="$t('adminAnnouncementsTranslation.adminAnnouncements')"
          >
            <i class="fas fa-bullhorn fa-lg"></i>
          </router-link>
          <router-link
            tag="li"
            to="/preferences"
            id="navPreferences"
            exact
            v-tooltip="$t('preferencesTranslation.preferences')"
            :class="{ spaceNotAdmin: !isAdmin }"
          >
            <i class="fas fa-cog fa-lg"></i>
          </router-link>
          <router-link
            tag="li"
            to="/logout"
            id="navLogout"
            v-tooltip="$t('logoutTranslation.logout')"
          >
            <i class="fa fa-sign-out-alt fa-lg"></i>
          </router-link>
        </div>
      </nav>

      <div
        v-if="!isLoginPage && $route.name !== 'logout' && announcementsAvailable && showAnnouncements"
        id="announcement"
        class="wrapper announcement"
        :class="[getAnnouncementClass(getAnnouncements[selectedAnnouncement])]"
      >
        <p class="wrapper">
          <label class="alignCenter col secAnnLeft">
            {{ getAnnouncements[selectedAnnouncement].attributes.title }}
          </label>
          <section class="announcementButtons closeAnnButton col">
            <button id="closeAnnouncement" @click="hideAnnouncements">
              <i class="fa fa-times fa-sm"></i>
            </button>
          </section>
        </p>
        <p>
          {{ getAnnouncements[selectedAnnouncement].attributes.message }}
        </p>
        <div class="alignCenter announcementButtons">
          <button v-if="selectedAnnouncement > 0" @click="previousAnnouncement">
            <i class="fa fa-chevron-left fa-sm" id="announcementsBack"></i>
          </button>
          {{ selectedAnnouncement + 1 }} {{ $t("generalTranslation.of") }} {{ getAnnouncements.length }}
          <button v-if="selectedAnnouncement < getAnnouncements.length - 1" @click="nextAnnouncement">
            <i class="fa fa-chevron-right fa-sm" id="announcementsNext"></i>
          </button>
        </div>
      </div>
      <router-view/>
    </header>

    <footer class="footer">
      <i
        :id="topButtonId"
        v-tooltip="$t('appTranslation.topButton')"
        class="fa fa-arrow-circle-up fa-2x"
        @click="topFunction()"
      ></i>
    </footer>
  </div>
</template>

<script>
import "floating-vue/dist/style.css";
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";

Vue.prototype.$urlBase = process.env.VUE_APP_API_URL;
Vue.prototype.$urlAuth = process.env.VUE_APP_AUTH_URL;
Vue.prototype.$url = Vue.prototype.$urlBase + "/api/v1";
Vue.prototype.$urlUploads = Vue.prototype.$urlBase + "/uploads";
Vue.prototype.$urlUploadsOld = [
  "https://aas2api.klips-ulm.de/uploads",
  "https://api.aas2.klips.ifp.uni-ulm.de/uploads",
  "https://intervention.api.aas2.klips.ifp.uni-ulm.de/uploads",
  "https://api.esano-trainings.de/uploads",
  "https://buddy.api.aas2.klips.ifp.uni-ulm.de/uploads",
  "https://api.esano-research.klips-ulm.de/uploads",
  "https://api.esano-research2.klips-ulm.de/uploads",
];
Vue.prototype.$perPage = 15;
Vue.prototype.$defaultLessonPageColor = "#fefcf0";
Vue.prototype.$tokenTime = 60;
Vue.prototype.$enabledFeatures = ["buddy", "jitai", "progress", "skills", "deletion-requests"];
//research: ["buddy", "jitai", "progress", "skills"]
//all features: ["buddy", "jitai", "progress", "skills", "deletion-requests"]
Vue.prototype.$supportMail = Vue.prototype.$url.includes("research") ? "support.esano-research@klips-ulm.de" : "support@esano-trainings.de";

require("./app.css");

export default {
  name: "app",

  data: function() {
    return {
      selectedAnnouncement: 0,
      showAnnouncements: false,
      topButtonId: "topButton",
      dropdownId: "dropdownContent",
      selectableLanguages: ["de", "en"],
      selectedAppLanguage: "en",
    };
  },

  computed: {
    ...mapGetters([
      "getAnnouncements",
      "getAppLanguage",
      "getAvailableLocales",
      "getRoles",
    ]),

    isEditor: function() {
      return this.getRoles.includes("editor");
    },

    isAdmin: function() {
      return this.getRoles.includes("admin");
    },

    isLoginPage: function() {
      return this.$route.name === "login" || this.$route.name === "resetPassword";
    },

    showHomeButton: function() {
      const route = this.$route.name;
      return (
        route !== "login" &&
        route !== "resetPassword" &&
        route !== "logout" &&
        route !== "privacy" &&
        route !== "imprint"
      );
    },

    isDevelopVersion: function() {
      return !this.$url.includes("esano");
    },

    routeNeedsDevPadding: function() {
      const route = this.$route.name;
      return (
        route === "interventionEditor" ||
        route === "lessonEditor" ||
        route === "diaryEditor" ||
        route === "skillEditor"
      );
    },

    announcementsAvailable: function() {
      return this.getAnnouncements.length > 0;
    },
  },

  created() {
    this.selectedAppLanguage = this.getAppLanguage === "de" ? "de" : "en";
    this.changeAppLanguage();
    const self = this;
    window.onscroll = function() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById(self.topButtonId).style.display = "block";
      } else {
        document.getElementById(self.topButtonId).style.display = "none";
      }
    };
    window.onclick = function(e) {
      if (!e.target.matches(".dropbtn")) {
        const dropdownMenu = document.getElementById(self.dropdownId);
        if (dropdownMenu?.classList.contains("showDropdown")) {
          dropdownMenu.classList.remove("showDropdown");
        }
      }
    };
    //refresh on other pages than login, resetPassword, home, adminAnnouncements
    if (
      this.$route.name !== "login" &&
      this.$route.name !== "resetPassword" &&
      this.$route.name !== "home" &&
      this.$route.name !== "adminAnnouncements" &&
      localStorage.getItem("announcements") != null
    ) {
      const announcements = JSON.parse(localStorage.getItem("announcements"));
      this.showAnnouncements = announcements.show;
      this.selectedAnnouncement = announcements.number;
      localStorage.removeItem("announcements");
    }
  },

  mounted() {
    window.addEventListener("unload", this.unloadFunction);
  },

  beforeDestroy() {
    window.removeEventListener("unload", this.unloadFunction);
  },

  watch: {
    $route(newVal, oldVal) {
      if (newVal.name === "login" || newVal.name === "resetPassword" || newVal.name === "logout") {
        this.selectedAnnouncement = 0;
      }
      if (newVal.name === "home" && oldVal.name === "login" && this.announcementsAvailable) {
        this.showAnnouncements = true;
      }
    },

    getAnnouncements(newVal, oldVal) {
      let announcements = localStorage.getItem("announcements");
      if (announcements != null) {
        announcements = JSON.parse(announcements);
        this.showAnnouncements = announcements.show;
        this.selectedAnnouncement = announcements.number;
        localStorage.removeItem("announcements");
      } else if (newVal.length > 0 && oldVal.length < newVal.length) {
        this.showAnnouncements = true;
        this.selectedAnnouncement = newVal.length - 1;
      } else if (this.selectedAnnouncement > newVal.length - 1) {
        this.selectedAnnouncement = newVal.length - 1;
      }
    },

    getAppLanguage(newVal) {
      this.selectedAppLanguage = newVal === "de" ? "de" : "en";
    },
  },

  methods: {
    ...mapMutations([
      "SET_APPLANGUAGE",
    ]),

    topFunction: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    showDropdownContent: function() {
      document.getElementById(this.dropdownId).classList.toggle("showDropdown");
    },

    previousAnnouncement: function() {
      this.selectedAnnouncement--;
    },

    nextAnnouncement: function() {
      this.selectedAnnouncement++;
    },

    hideAnnouncements: function() {
      this.showAnnouncements = false;
    },

    showHideAnnouncements: function() {
      this.showAnnouncements = !this.showAnnouncements;
    },

    changeAppLanguage: function() {
      Vue.i18n.set(this.selectedAppLanguage);
      this.SET_APPLANGUAGE(this.selectedAppLanguage);
    },

    unloadFunction: function() {
      const announcements = JSON.stringify({
        show: this.showAnnouncements,
        number: this.selectedAnnouncement,
      });
      localStorage.setItem("announcements", announcements);
    },

    getAnnouncementClass(announcement) {
      switch (announcement.attributes.type) {
        case "error":
          return "textImportant";
        case "warning":
          return "textTip";
        case "info":
          return "textInfo";
        case "success":
          return "textSuccess";
      }
    },
  },
}
</script>

<style scoped>
.loginRegister {
  width: 375px;
  margin-left: 36vw;
  margin-right: 36vw;
  margin-top: 20vh;
  border: 1px solid black;
  border-radius: 5px;
}

.navbar {
  width: 100%;
  background-color: var(--colorDark);
  padding-left: 16px;
  padding-right: 0px;
  color: var(--colorLight);
  left: 0;
  top: 0;
  position: fixed;
  list-style-type: none;
  z-index: 2;
  height: 48px;
  max-height: 48px;
  font-size: 17px;
  display: flex;
}
.navbar section {
  display: inline-block;
}
.navbar li, .navbar button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  padding-right: 15px;
}
.navbar li:hover {
  color: var(--colorHoverSelected);
  cursor: pointer;
}

.secNavTexts {
  flex: 1 1 500px;
  vertical-align: middle;
}
.navbarIcon {
  height: 48px;
}
.secNavButtons {
  vertical-align: middle;
  padding: 12.5px 0px;
}
.secNavButtons li {
  vertical-align: middle;
  padding-right: 10px;
  height: 23px;
}

.devMarker {
  color: #EB445A;
  font-weight: 600;
  padding-right: 40px;
}
.devMarkerPadding {
  padding-right: 210px;
}

.dropbtn {
  cursor: pointer;
  border: none;
  outline: none;
  background-color: inherit;
  margin: 0;
  padding: 0px;
}
.dropdown-content {
  display: none;
  position: absolute;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 3;
  background-color: var(--colorDark);
  margin-top: 12px;
  margin-left: -10px;
}
.dropdown-content li {
  float: none;
  padding: 12px 10px;
  display: block;
  text-align: left;
}
.showDropdown {
  display: block;
}

.annButton {
  padding-right: 10px;
}
.annActive {
  color: var(--colorHoverSelected);
}

.spaceNotAdmin {
  margin-left: 68px;
}

.announcement {
  padding-left: 30px !important;
  padding-right: 30px !important;
  white-space: pre-wrap;
  margin-bottom: 35px !important;
}
.announcementButtons {
  padding-bottom: 8px;
  margin-bottom: 10px;
}
.announcementButtons button {
  background-color: transparent;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.announcementButtons i {
  color: var(--colorDark);
}
.closeAnnButton {
  text-align: right;
}
.secAnnLeft {
  width: 95%;
}

.footer {
  height: 40px;
  padding: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  position: fixed;
}
.footer .fa-arrow-circle-up {
  display: none;
  float: right;
  z-index: 2;
  margin-right: 10px;
  margin-bottom: 10px;
}

.alignCenter {
  text-align: center;
}
</style>
